import React from "react";
import { AccessData } from "../../api/models/access-model";
import IconifyIcon from "../IconifyIcon";
import { useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import dayjs from "dayjs";

interface LogCardProps {
  log: AccessData | null;
  style?: React.CSSProperties;
  onPress: () => void;
}

const LogCard = ({ log, style, onPress }: LogCardProps) => {
  const labels = useAppSelector(selectLabels);

  return (
    <div className="card border-box gap-4" style={style} onClick={onPress}>
      <div className="w-70 border-box p-4">
        <div className="w-100 border-box flex align-items-center justify-content-between">
          <div className="w-100 flex align-items-center">
            <p className="font-16 font-w-700 subtitle-color">
              {log?.visitor}
            </p>
          </div>
        </div>
        <div className="w-100 border-box flex align-items-center mt-5">
          <div className="flex align-items-center" style={{ minWidth: 40 }}>
            <IconifyIcon
              icon={
                log?.entrance_transaction?.access_key_id ||
                log?.exit_transaction?.access_key_id
                  ? "arcticons:qr"
                  : "arcticons:simple-clipboard-editor"
              }
              style={{ fontSize: 34 }}
              className="title-color"
            />
          </div>
          <div className="pl-2" style={{ width: "calc(100% - 40px)" }}>
            <p className="font-14 subtitle-color">{log?.visitor}</p>
            <p className="font-12 subtitle-color mt-2">
              {log?.unit}
            </p>
          </div>
        </div>
      </div>
      <div className="w-100 border-box flex align-items-center justify-content-end">
        <div className="border-box flex flex-dir-col align-items-end justify-content-center">
          {log?.entrance_transaction !== null && (
            <div
              className="w-100 border-box pr-5 flex align-items-center justify-content-end"
              style={{
                paddingBottom: log?.exit_transaction?.datetime
                  ? !log?.authorized
                    ? 0
                    : 0
                  : !log?.authorized
                  ? 4
                  : 10,
              }}
            >
              <p
                className="font-14 subtitle-color mt-2"
                style={{ whiteSpace: "nowrap" }}
              >
                {labels.entrance}:{" "}
                <span className="font-w-500">
                  {dayjs(
                    log?.entrance_transaction?.datetime
                  ).format("DD/MM hh:mm")}
                </span>
              </p>
            </div>
          )}
          {log?.exit_transaction?.datetime && (
            <div
              className="border-box pr-5 flex align-items-center justify-content-end"
              style={{ paddingBottom: !log?.authorized ? 4 : 10 }}
            >
              <p
                className="font-14 subtitle-color mt-2"
                style={{ whiteSpace: "nowrap" }}
              >
                {labels.exit}:{" "}
                <span className="font-w-500">
                  {dayjs(
                    log?.exit_transaction?.datetime
                  ).format("DD/MM hh:mm")}
                </span>
              </p>
            </div>
          )}
        </div>
        {!log?.authorized && (
          <div className="border-box flex align-items-center justify-content-end p-5">
            <IconifyIcon
              icon={"entypo:block"}
              style={{ fontSize: 24 }}
              className="title-color"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LogCard;
